var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 7.99992C7.26675 7.99992 6.66675 7.39992 6.66675 6.66659C6.66675 5.93325 7.26675 5.33325 8.00008 5.33325C8.73341 5.33325 9.33341 5.93325 9.33341 6.66659C9.33341 7.39992 8.73341 7.99992 8.00008 7.99992ZM12.0001 6.79992C12.0001 4.37992 10.2334 2.66659 8.00008 2.66659C5.76675 2.66659 4.00008 4.37992 4.00008 6.79992C4.00008 8.35992 5.30008 10.4266 8.00008 12.8933C10.7001 10.4266 12.0001 8.35992 12.0001 6.79992ZM8.00008 1.33325C10.8001 1.33325 13.3334 3.47992 13.3334 6.79992C13.3334 9.01325 11.5534 11.6333 8.00008 14.6666C4.44675 11.6333 2.66675 9.01325 2.66675 6.79992C2.66675 3.47992 5.20008 1.33325 8.00008 1.33325Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.a60d03f21db38f4f3d2413cf1e2ab7fb.svg";
export { ForwardRef as ReactComponent };